import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

//Components
import UGCCardChips from './UGCCardChips';

//Selectors
import {highlightedAmenitiesSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

const AmenityChips = () => {
  const [amenitiesChipsData, updateAmenitiesChipsData] = useState([]);

  const hotelAmenitiesData = useSelector(highlightedAmenitiesSelector) || [];

  useEffect(() => {
    hotelAmenitiesData;
    if (hotelAmenitiesData && hotelAmenitiesData.length) {
      updateAmenitiesChipsData(hotelAmenitiesData);
    }
  }, [hotelAmenitiesData]);

  return <UGCCardChips amenitiesData={amenitiesChipsData} />;
};

export default AmenityChips;
